import { API } from '@redux/services/api';
import { apiRequest } from './common';

const withBaseUrl = (endpoint) => `${API.BASE_URL}${endpoint}`;

export const startBachelorPoint = async (options = {}) => {
  return apiRequest({
    url: withBaseUrl(API.API_BACHELOR_POINT_START),
    method: 'POST',
    ...options
  });
};

export const createBachelorPointExchangeRequest = async (options = {}) => {
  return apiRequest({
    url: withBaseUrl(API.API_BACHELOR_POINT_EXCHANGE_REQUEST_POINT),
    method: 'POST',
    ...options
  });
};

export const fetchBachelorPointHistory = async (options = {}) => {
  return apiRequest({
    url: withBaseUrl(API.API_BACHELOR_POINT_GET_POINT_HISTORY),
    method: 'GET',
    ...options
  });
};

export const fetchBachelorPointProducts = async (options = {}) => {
  return apiRequest({
    url: withBaseUrl(API.API_BACHELOR_POINT_GET_POINT_PRODUCTS),
    method: 'GET',
    ...options
  });
};

export const fetchBachelorPointIsEnabled = async (options = {}) => {
  return apiRequest({
    url: withBaseUrl(API.API_BACHELOR_POINT_IS_ENABLED),
    method: 'GET',
    ...options
  });
};
